// Utility to format date string based on format
export const formatCycleInfoDate = (
  dateStr?: string,
  format: 'DD MMM' | 'MMM DD' | 'MMM DD YYYY' | 'DD MMM YYYY' | 'DDDD, MMM DD YYYY' | 'MMM DD, YYYY' | 'DD MMM, YYYY' = 'DD MMM'
) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  if (isNaN(date.getTime())) return dateStr; // fallback if invalid
  const day = date.getDate();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthName = months[date.getMonth()];
  const year = date.getFullYear();
  const dayName = days[date.getDay()];
  if (format === 'DD MMM') return `${day} ${monthName}`;
  if (format === 'MMM DD') return `${monthName} ${day}`;
  if (format === 'MMM DD YYYY') return `${monthName} ${day} ${year}`;
  if (format === 'DD MMM YYYY') return `${day} ${monthName} ${year}`;
  if (format === 'MMM DD, YYYY') return `${monthName} ${day}, ${year}`;
  if (format === 'DD MMM, YYYY') return `${day} ${monthName}, ${year}`;
  if (format === 'DDDD, MMM DD YYYY') return `${dayName}, ${monthName} ${day} ${year}`;
  return `${day} ${monthName}`;
};

// Utility to normalize date format for comparison
export const normalizeDate = (dateStr: string): string => {
  if (!dateStr) return '';
  try {
    // Try to parse the date and return in YYYY-MM-DD format
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      // If invalid date, return original string
      return dateStr;
    }
    return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD format
  } catch (error) {
    console.warn('Error normalizing date:', dateStr, error);
    return dateStr;
  }
};

// Helper function to convert text to proper camel case
export const toCamelCase = (text: string): string => {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .split(/[\s_-]+/) // Split by spaces, underscores, or hyphens
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};


// Access calendarInfo from localStorage
export const getCalendarInfo = () => {
  try {
    const storedCalendarInfo = localStorage.getItem('calendarInfo');
    if (storedCalendarInfo) {
      return JSON.parse(storedCalendarInfo);
    }
    return null;
  } catch (error) {
    console.error('Error parsing calendarInfo from localStorage:', error);
    return null;
  }
};

/**
 * Parse date string and normalize to start of day (00:00:00.000)
 * @param dateString - Date string to parse
 * @returns Date object set to start of day
 */
export const parseAndNormalizeDate = (dateString: string): Date => {
  const date = new Date(dateString);
  date.setHours(0, 0, 0, 0);
  return date;
};

/**
 * Parse date string and normalize to end of day (23:59:59.999)
 * @param dateString - Date string to parse
 * @returns Date object set to end of day
 */
export const parseAndNormalizeEndOfDay = (dateString: string): Date => {
  const date = new Date(dateString);
  date.setHours(23, 59, 59, 999);
  return date;
};